import { connect } from "react-redux";
import ReshuffleRequest from "./ReshuffleRequest";
import {
  reshuffleRequests,
  reshuffleRequestLoading,
  reshuffleRequestPageLoading,
  reshuffleRequestPagination,
} from "../../store/selectors/reshuffleRequests.selector";
import {
  getReshuffleRequests,
  createReshuffleRequest,
  updateReshuffleRequest,
  deleteReshuffleRequest,
  submitReshuffleRequest,
  approveReshuffleRequest,
  rejectReshuffleRequest,
  executeReshuffleRequest,
  cancelReshuffleRequest,
} from "../../store/actions/reshuffleRequests.actions";

const mapStateToProps = (state) => ({
  allReshuffleRequests: reshuffleRequests(state),
  loading: reshuffleRequestLoading(state),
  pageLoading: reshuffleRequestPageLoading(state),
  pagination: reshuffleRequestPagination(state),
});

const mapDispatchToProps = {
  getReshuffleRequests,
  createReshuffleRequest,
  updateReshuffleRequest,
  deleteReshuffleRequest,
  submitReshuffleRequest,
  approveReshuffleRequest,
  rejectReshuffleRequest,
  executeReshuffleRequest,
  cancelReshuffleRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReshuffleRequest);
